module.exports = __webpack_public_path__ + "static/media/staffHeaderImg.d81d1a56.png";